module.exports = __webpack_public_path__ + "img/2.3d736b14.png";